module.exports = __webpack_public_path__ + "img/whatsapp.2ff847a4.png";